import _ from 'lodash'
import coreLogger from '@adc/logger'
import {
  DEFAULT_NOTIFICATION_OPTIONS,
  DISMISSIBLE_DURATION_THRESHOLD,
  DEFAULT_ERROR_TITLE,
  NOTIFICATION_ROLES,
} from './constants'

const logger = coreLogger.forModule('AUCTIONCOM')

function prepareErrorOptions(error, overrides) {
  const message =
    error.message ||
    error.statusText ||
    (error.body && (error.body.title || error.body.message)) ||
    error.toString()

  return {
    ...DEFAULT_NOTIFICATION_OPTIONS,
    title: DEFAULT_ERROR_TITLE,
    message: `Error: ${message}`,
    role: NOTIFICATION_ROLES.ERROR,
    ...overrides,
  }
}

class BaseNotifier {
  constructor(notificationSystem) {
    this._notificationSystem = null
    this._initialized = false
  }

  initialize(notificationSystem) {
    this._notificationSystem = notificationSystem
    this._initialized = true
  }

  get notificationSystem() {
    return this._notificationSystem
  }

  get initialized() {
    return this._initialized
  }

  prepareErrorOptions(error, overrides) {
    return prepareErrorOptions(error, overrides)
  }

  prepareOptions(initialOptions) {
    let options = initialOptions

    /**
     * If error is passed in, dissect the error to create options
     */
    if (initialOptions.error) {
      options = this.prepareErrorOptions(
        initialOptions.error,
        _.omit(initialOptions, 'error')
      )
    }

    options = {
      ...DEFAULT_NOTIFICATION_OPTIONS,
      ..._.omitBy(options, val => _.isNil(val) || val === ''),
    }

    /**
     * Couple cases here where we want to force dismissible to true
     */
    if (
      (!options.autoDismiss ||
        // if duration is considerably long, make it dismissible so user can close it if they want
        options.duration > DISMISSIBLE_DURATION_THRESHOLD) &&
      !Object.prototype.hasOwnProperty.call(options, 'dismissible')
    ) {
      options.dismissible = true
    }
    return options
  }

  open(options) {
    if (!this._notificationSystem?.current?.open) {
      /**
       * If necessary, use setTimeout to ensure the notification system is initialized before opening.
       * This can issue can come up when the notification system is mounted and open is called immediately
       * in the same event loop.
       */
      setTimeout(() => {
        this._notificationSystem?.current?.open(options) ||
          logger.warn(
            'Notification system not initialized, cannot open notification'
          )
      }, 0)
    } else {
      this._notificationSystem?.current?.open(options)
    }
  }

  close() {
    this._notificationSystem?.current?.close()
  }

  destroy() {
    // placeholder for general garbage collection
  }
}

export { BaseNotifier }
